import { UICommandContext } from "../../../library-js/dom-ui/commands/UICommandContext";
import { UICommand } from "../../../library-js/dom-ui/commands/UICommand";
import { UICommandManager } from "../../../library-js/dom-ui/commands/UICommandManager";
import { NodeGraph } from "../model/NodeGraph";
import { Delete } from "./Delete";

export class NGCommandContext extends UICommandContext
{
  variables:Map<string,boolean> = new Map<string,boolean>();
  
  is( variable:string )
  {
    return this.variables.has( variable ) && this.variables.get( variable );
  }

}

